import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom"; // Import BrowserRouter
import Navbar from "./Components/Navbar";
import AboutUs from "./Components/AboutUs";
import ContactSection from "./Components/ContactSection";
import Footer from "./Components/Footer";
import "./App.css";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to track menu open status

  return (
    <Router>
      <div className="App">
        <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <AboutUs isMenuOpen={isMenuOpen} />
        <ContactSection />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
